import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512.000000 512.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M0 2560 l0 -2560 2560 0 2560 0 0 2560 0 2560 -2560 0 -2560 0 0
-2560z m2805 1205 c55 -15 124 -40 153 -56 29 -16 58 -29 63 -29 26 0 209
-140 209 -160 0 -15 -91 -100 -107 -100 -8 0 -32 15 -53 33 -50 43 -197 119
-285 149 -62 20 -89 23 -235 23 -127 0 -180 -4 -230 -18 -100 -28 -243 -104
-324 -174 -22 -18 -44 -33 -50 -33 -13 0 -106 91 -106 103 0 6 12 21 28 34
154 138 338 225 534 253 110 15 291 4 403 -25z m948 -417 c11 -687 9 -892 -7
-983 -17 -91 -44 -186 -57 -199 -5 -6 -9 -16 -9 -24 0 -22 -76 -167 -131 -249
-52 -77 -190 -224 -259 -276 -68 -50 -142 -97 -155 -97 -7 0 -15 -3 -17 -7 -3
-8 -50 -32 -108 -56 -165 -66 -248 -81 -465 -81 -168 -1 -200 2 -280 23 -49
12 -94 27 -100 32 -5 5 -17 9 -28 9 -18 0 -207 86 -217 99 -3 3 -25 19 -50 35
-275 177 -479 500 -526 834 -17 123 -38 1331 -23 1346 5 6 61 -41 141 -120 73
-72 151 -148 173 -168 44 -42 506 -490 646 -628 l89 -87 0 -88 c0 -113 13
-159 59 -204 42 -42 87 -55 157 -44 36 5 55 16 90 51 l44 45 0 117 c0 85 4
123 14 138 8 11 63 70 123 131 641 657 823 846 823 856 0 4 6 7 14 7 8 0 16 7
20 15 3 8 12 15 19 15 11 0 15 -78 20 -442z m-1043 147 c84 -17 207 -73 276
-127 30 -24 54 -45 54 -48 0 -3 -25 -30 -55 -60 -41 -40 -59 -52 -68 -45 -63
47 -135 87 -188 106 -77 27 -210 36 -294 20 -73 -14 -188 -67 -237 -110 -20
-17 -42 -31 -49 -30 -8 1 -36 26 -64 56 -56 62 -59 50 25 113 18 14 39 31 46
38 7 6 15 12 18 12 3 0 34 13 69 29 146 67 290 81 467 46z m-1 -298 c41 -17
87 -42 103 -56 l29 -26 -54 -58 -54 -58 -54 32 c-48 29 -62 33 -134 33 -74 1
-84 -2 -134 -32 -60 -37 -54 -38 -130 36 l-43 43 28 24 c15 13 46 32 68 43
146 69 240 74 375 19z m-94 -237 c44 -17 42 -37 -11 -91 -26 -27 -53 -49 -59
-49 -13 0 -115 100 -115 112 0 30 128 50 185 28z"
          />
          <path
            d="M3268 2972 c-75 -75 -149 -151 -165 -168 -30 -32 -30 -32 -36 -185
-6 -162 -13 -192 -64 -286 -87 -157 -222 -245 -410 -267 -114 -14 -257 28
-356 102 -82 63 -140 141 -177 243 -27 73 -32 101 -36 214 l-6 130 -166 162
c-102 99 -170 159 -176 153 -5 -5 -7 -134 -3 -317 6 -330 10 -360 69 -504 90
-218 285 -407 498 -482 249 -88 510 -70 730 51 149 82 282 222 359 379 85 175
91 209 91 590 0 171 -4 314 -8 317 -5 3 -70 -56 -144 -132z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
